import { create } from "zustand";

import { globalCreateOpportunitysSlice } from "./slice";
import type { ZGlobalCreateOpportunity } from "./types";

export const useGlobalCreateOpportunityStore =
  create<ZGlobalCreateOpportunity>()((...args) => ({
    ...globalCreateOpportunitysSlice(...args),
  }));
